import { render } from "./Docs.vue?vue&type=template&id=7f9d7a2c"
import script from "./Docs.vue?vue&type=script&lang=js"
export * from "./Docs.vue?vue&type=script&lang=js"
script.render = render

export default script